$component: 'zr-product-variants';

.manufacturer {
    font-size: 16px;
    text-align: left;
}

h3 {
    font-size: 18px;
    margin-top: 0;
    text-align: left;
}

.warning-info {
    margin-bottom: 16px;
}

.variant-not-available {
    opacity: 0.5;
}

.variant-item {
    display: flex;
    text-align: left;
    align-items: center;

    & + .variant-item {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid var(--ci-neutral400);
    }

    & :first-child {
        flex: 1;
        font-size: 16px;
        margin: 0;
        font-weight: 400;

        &.variant-main {
            font-weight: 600;
        }
    }
}

.variant-add {
    text-align: right;
    position: relative;
    padding: 12px 8px 8px;
}

zr-warning-notice + zr-warning-notice {
    margin-top: 16px;
}

.variant-add-disabled {
    background-color: var(--vx-atcc-background-color);
    transition: background-color 0.3s ease;
    right: 0;
    user-select: none;
    height: 44px;
    width: 44px;
    border: none;
    border-radius: var(--vx-add-to-cart-count__border-radius, 8px);
    cursor: pointer;

    &:focus {
        outline: 3px solid var(--ci-primary600);
        outline-offset: -1px;
    }

    &:hover {
        background-color: var(--vx-atcc-background-hover-color, #006B7E);
    }

    &:active {
        background-color: var(--vx-atcc-background-hover-color, #00505E);
    }

    &:disabled {
        cursor: default;
        background-color: var(--ci-neutral500);
    }
}

.variant-to-cart__wrapper {
    margin-top: 30px
}

zr-price {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
    min-width: 150px;

    --zr-current-price-font-size: 18px;
    --zr-current-price-line-height: 18px;
    --zr-recommended-price-font-size: 12px;
    --zr-recommended-price-line-height: 12px;
    --zr-current-price-per-unit-font-size: 12px;
    --zr-current-price-per-unit-line-height: 12px;
}
